import { useState } from 'react';
import clsx from 'clsx';
import { $messageCentreStore } from '@lib/store';
import { DateUtils } from '@shared/utils';
import type { ThreadWithMessages } from '@shared/api/rest/messages';
import { MessageWrapper } from './messageWrapper';
import { Message } from './message';
import { Reply } from './reply';
import { DeleteThreadModal } from './deleteThreadModal';
import { Button, ColorsEnum, Icon, Text } from '@shared/widgets';
import MessageSquareIcon from '@assets/icons/message-square.svg';
import MoreIcon from '@assets/icons/more.svg';

interface IMessageThread {
  thread: ThreadWithMessages;
}

export const MessageThread = (props: IMessageThread) => {
  const [showMessagesList, setShowMessagesList] = useState<boolean>(false);
  const [showReply, setShowReply] = useState<boolean>(false);
  const [showMenu, setShowMenu] = useState<boolean>(false);
  const [showDeleteThreadModal, setShowDeleteThreadModal] = useState<boolean>(false);

  const deleteThread = () => {
    $messageCentreStore.events.deleteThread(props.thread.groupId);
    setShowMenu(false);
    setShowDeleteThreadModal(false);
  };

  // TODO: NEED IMPLEMENTATION
  // const readingThread = () => {
  //   readThread({ groupId: thread.groupId });
  //   setShowMenu(false);
  // };

  const handleClick = async (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    e.stopPropagation();
    setShowMessagesList(!showMessagesList);
    showReply && setShowReply(false);
    await $messageCentreStore.events.readThread({
      groupId: props.thread.groupId,
    });
  };

  return (
    <>
      <MessageWrapper
        parentClName='cursor-pointer'
        childClName={clsx(showMessagesList && 'border-l-2 border-l-primary', !props.thread?.allRead && 'bg-beige border border-primary')}
        onClick={(e) => {
          handleClick(e);
        }}
      >
        <div className='flex-auto min-w-[0]'>
          <Text className='mb-2' size='sm' color={ColorsEnum.Gray}>
            {DateUtils.formatDate(props.thread.lastCreatedOn, { withTime: true })}
          </Text>
          <Text className='mb-2 font-bold text-xl'>{props.thread?.subject}</Text>
        </div>
        <div className='flex-none flex flex-col items-end ml-5'>
          <div className='relative'>
            <Button
              className='w-6 h-6 !p-0 text-2xl text-slate dark:text-gray-white hover:opacity-70 focus:opacity-70 before:hidden'
              onClick={(e) => {
                e.stopPropagation();
                setShowMenu((prev) => !prev);
              }}
            >
              <Icon icon={<MoreIcon />} />
            </Button>
            <ul
              className={clsx(
                showMenu
                  ? 'py-2.5 rounded-sm shadow-[0px_0px_20px_#0000001a] bg-white dark:bg-soft-black absolute right-0 top-full text-sm list-none min-w-40 mt-3 opacity-100 cursor-pointer transition-all duration-300 ease-out'
                  : 'py-2.5 rounded-sm shadow-[0px_0px_20px_#0000001a] bg-white dark:bg-soft-black absolute right-0 top-full text-sm  list-none min-w-40 mt-3 opacity-0 invisible pointer-events-none transition-all duration-300 ease-out',
              )}
            >
              {/*
              TODO: NEED IMPLEMENTATION
              <li
                className="py-1 px-6 transition-colors duration-300 ease-out hover:bg-yellow-brown"
                onClick={(e) => {
                  e.stopPropagation();
                  readingThread();
                }}
              >
                Mark as resolved 
              </li> */}
              <li
                className='py-1 px-6 transition-colors duration-300 ease-out hover:bg-yellow-brown'
                onClick={(e) => {
                  e.stopPropagation();
                  setShowMessagesList(true);
                  setShowReply(true);
                  setShowMenu(false);
                }}
              >
                Reply
              </li>
              <li
                className='py-1 px-6 text-red transition-colors duration-300 ease-out hover:bg-yellow-brown'
                onClick={(e) => {
                  e.stopPropagation();
                  setShowDeleteThreadModal(true);
                }}
              >
                Delete
              </li>
            </ul>
          </div>
          <div className='mt-auto'>
            <div className='flex items-center gap-2'>
              <Icon icon={<MessageSquareIcon />} />
              <span>{props.thread?.messages?.length || 0}</span>
            </div>
          </div>
        </div>
      </MessageWrapper>
      {showMessagesList &&
        props.thread?.messages?.map((message) => (
          <Message key={message.messageId} message={message} onClickReply={() => setShowReply((prev) => !prev)} />
        ))}
      {showReply && <Reply thread={props.thread} onReply={() => setShowReply(false)} />}
      <DeleteThreadModal open={showDeleteThreadModal} close={() => setShowDeleteThreadModal(false)} deleteThread={deleteThread} />
    </>
  );
};
